import { FC, useState } from 'react'
import { selectCurrentPage, setCurrentPage } from 'src/app/page'
import { Tab, Page } from 'src/app/types'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import HomeIcon from '../../Icon/HomeIcon'
import { HeaderIconType } from '../../Icon/types'
import LeaderBoardIcon from '../../Icon/LeaderBoardIcon'
import SettingsIcon from '../../Icon/SettingsIcon'

type NavigationMenuProps = {
  name: Tab
}

// certain pages still reside within other tabs
const active: Record<Tab, Set<Page>> = {
  Home: new Set(['Home', 'Session', 'AllSessions']),
  Leaderboard: new Set(['Leaderboard']),
  Settings: new Set(['Settings']),
}

const NavigationMenu: FC<NavigationMenuProps> = ({ name }) => {
  const [isHover, setIsHover] = useState(false)
  const currentTab = useAppSelector(selectCurrentPage)
  const dispatch = useAppDispatch()
  const isActive = active[name].has(currentTab)
  const iconType: HeaderIconType = isActive
    ? 'active'
    : isHover
    ? 'hover'
    : 'nonActive'

  const onClick = () => {
    dispatch(setCurrentPage({ page: name }))
  }

  return (
    <div className="sm:w-full" onClick={onClick}>
      <li
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={`cursor-pointer w-20 h-[72px] pt-4 hover:text-black sm:w-full sm:h-fit flex flex-col items-center sm:flex-row sm:items-center sm:pb-4 sm:pl-6 sm:border-none ${
          isActive && 'border-b-[3px] border-primaryBlue'
        }`}
      >
        <div className="sm:mr-4">
          {name === 'Home' ? (
            <HomeIcon iconType={iconType} />
          ) : name === 'Leaderboard' ? (
            <LeaderBoardIcon iconType={iconType} />
          ) : (
            <SettingsIcon iconType={iconType} />
          )}
        </div>
        <p className={`${isActive && 'text-primaryBlue'} text-xs mt-2 sm:mt-0`}>
          {name}
        </p>
      </li>
    </div>
  )
}

export default NavigationMenu
